module.exports = __webpack_public_path__ + "img/chairs-and-chaises.4b34adf.png";